<div class="share">
  <div class="share__email-container" [matTooltip]="tooltipMaker('email')">
    <a [href]="shareMail()" data-cy="deelViaEmail">
      <img class="svg" src="assets/icons/envelope-regular.svg" alt="email" />
    </a>
  </div>
  <div class="share__link-container" [matTooltip]="tooltipMaker('link')" (click)="linkCopiedPopup()">
    <a (click)="copyDeepLink()" data-cy="deelViaLink">
      <img class="svg" src="assets/icons/link-solid.svg" alt="link" />
    </a>
  </div>
  <div class="share__whatsapp-container" [matTooltip]="tooltipMaker('whatsapp')">
    <a [href]="shareWhatsapp()" data-cy="deelViaWhatsApp" target="_blank" rel="noopener">
      <img class="svg" src="assets/icons/whatsapp-brands.svg" alt="whatsapp" />
    </a>
  </div>
  <div class="share__print-container" [matTooltip]="tooltipMaker('print')">
    <a (click)="openPrintableScreen()" data-cy="deelViaPrint">
      <img class="svg" src="assets/icons/print-solid.svg" alt="print" />
    </a>
  </div>
</div>
